import { Row } from "antd";
import React from "react";

export default function Banner() {
  return (
    <Row className="banner">
      <div className="mask">
        <Row className="content">
          <h2>Feature rich with more to come!</h2>
          <p className="w-font-md fw-600">
            Virl Marketplace is constantly growing, just like the possibilities
            for your embed! Join the conversation on Discord or GitHub on what
            to include next.
          </p>
        </Row>
      </div>
    </Row>
  );
}
